var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnFlagged = function SvgIcnFlagged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06 1.945c.953.172 1.645 1.013 1.758 2.01l.849 6.084H2.333l.848-6.074c.114-1.002.813-1.844 1.771-2.015 1.487-.267 2.678-.264 4.107-.005ZM5.147 8.492l.528-4.377a.6.6 0 0 0-.506-.676.588.588 0 0 0-.652.526l-.527 4.377a.6.6 0 0 0 .506.675.588.588 0 0 0 .651-.525Z",
    fill: "#292525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.25h10.5v-1.21H1.75v1.21Z",
    fill: "#292525"
  })));
};
export default SvgIcnFlagged;